window.config = window.config || {};
window.config.filerevSummary = null;

window.prerenderReady = false;

if (!window.location.origin) {
  window.location.origin = `${window.location.protocol}//${window.location.hostname}${window.location.port ? ':' + window.location.port : ''}`;
}
